import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1661486c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "three-d-part-card box",
  "data-unit": "three-d-part-details-card"
}
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = {
  key: 0,
  role: "status",
  "aria-live": "polite",
  "data-unit": "part-mapping-loading"
}
const _hoisted_4 = {
  key: 1,
  role: "status",
  "aria-live": "polite",
  "data-unit": "part-mapping-unavailable"
}
const _hoisted_5 = { class: "has-text-weight-semibold" }
const _hoisted_6 = {
  key: 2,
  role: "alert",
  "data-unit": "part-mapping-error"
}
const _hoisted_7 = {
  class: "has-text-weight-semibold part-name",
  "data-unit": "mapped-part-name"
}
const _hoisted_8 = {
  key: 0,
  class: "part-identity",
  "data-unit": "mapped-part-number"
}
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon far fa-copy" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  "data-unit": "mapped-part-supplier"
}
const _hoisted_13 = {
  key: 0,
  class: "part-identity",
  "data-unit": "unmapped-part-number"
}
const _hoisted_14 = ["aria-label"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon far fa-copy" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { "data-unit": "unmapped-part-message" }

import { computed } from 'vue'
import { useStore } from 'vuex'
import InfoAddToCart from './info/InfoAddToCart.vue'
import LoadingIcon from '@/components/common/LoadingIcon.vue'
import type { ViewerSelectedModelElement } from '@/components/admin/content/editor/three-d-model/AutodeskViewer.vue'
import type { Part } from '@/interfaces/library'

type MappedPart = Part & {
  displayName?: string
  partNumberVisible?: boolean
  supplierName?: string
  visible?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ThreeDPartDetailsCard',
  props: {
    element: {},
    part: {},
    pricingLoaded: { type: Boolean },
    status: {}
  },
  emits: ['close', 'retry'],
  setup(__props: any) {

const props = __props



const store = useStore()
const isVisible = computed(() => props.part?.visible !== false)
const showPartNumber = computed(() =>
  isVisible.value &&
  props.part?.partNumberVisible !== false &&
  !!props.part?.partNumber
)
const showSupplier = computed(() =>
  isVisible.value &&
  store.getters['user/displaySupplierPartInfo'] &&
  !!(props.part?.supplierName || props.part?.supplierKey)
)
const showOrdering = computed(() => isVisible.value && props.part?.orderable === true)
const orderingPartKey = computed(() => {
  const part = props.part
  return part?.id != null
    ? `id:${part.id}`
    : `part:${part?.supplierKey ?? ''}:${part?.partNumber ?? ''}`
})
const pricing = computed(() => ({ ...props.part, isLoaded: props.pricingLoaded }))
const addToCartQtyBehavior = computed(() => store.state.user.preferences.addToCartQtyBehavior)
const displayAvailability = computed(() => store.getters['user/displayAvailability'])
const displayDiscounted = computed(() => store.getters['user/displayDiscounted'])
const displayEta = computed(() => store.getters['user/displayEta'])
const displayRetail = computed(() => store.getters['user/displayRetail'])
const displayWholeSale = computed(() => store.getters['user/displayWholeSale'])
const isCartOrErpCartEnabled = computed(() => store.getters['user/isCartOrErpCartEnabled'])

function copyPartNumber (partNumber?: string | null) {
  if (partNumber) navigator.clipboard.writeText(partNumber)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("button", {
      class: "delete close-card",
      type: "button",
      "aria-label": _ctx.$t('close'),
      "data-unit": "close-three-d-part-card",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
    }, null, 8, _hoisted_2),
    (_ctx.status === 'loading')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(LoadingIcon)
        ]))
      : (_ctx.status === 'unavailable')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('threeD.partInformationUnavailable')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('threeD.partInformationUnavailableHelp')), 1)
          ]))
        : (_ctx.status === 'error')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('threeD.partInformationError')), 1),
              _createElementVNode("button", {
                class: "button is-small",
                type: "button",
                "data-unit": "retry-part-mapping",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('retry')))
              }, _toDisplayString(_ctx.$t('tryAgain')), 1)
            ]))
          : (_ctx.status === 'ready' && _ctx.part)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.part.name || _ctx.part.displayName), 1),
                (showPartNumber.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('partNumber')) + ": " + _toDisplayString(_ctx.part.partNumber), 1),
                      _createElementVNode("button", {
                        class: "button is-white is-small copy-button",
                        type: "button",
                        "aria-label": _ctx.$t('copy'),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (copyPartNumber(_ctx.part.partNumber)))
                      }, _hoisted_11, 8, _hoisted_9)
                    ]))
                  : _createCommentVNode("", true),
                (showSupplier.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.$t('supplier')) + ": " + _toDisplayString(_ctx.part.supplierName || _ctx.part.supplierKey), 1))
                  : _createCommentVNode("", true),
                (showOrdering.value)
                  ? (_openBlock(), _createBlock(InfoAddToCart, {
                      key: orderingPartKey.value,
                      "add-to-cart-qty-behavior": addToCartQtyBehavior.value,
                      content: _ctx.part,
                      "display-availability": displayAvailability.value,
                      "display-discounted": displayDiscounted.value,
                      "display-eta": displayEta.value,
                      "display-retail": displayRetail.value,
                      "display-whole-sale": displayWholeSale.value,
                      "is-cart-or-erp-cart-enabled": isCartOrErpCartEnabled.value,
                      pricing: pricing.value,
                      "show-pricing-for-parts": ""
                    }, null, 8, ["add-to-cart-qty-behavior", "content", "display-availability", "display-discounted", "display-eta", "display-retail", "display-whole-sale", "is-cart-or-erp-cart-enabled", "pricing"]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_ctx.status === 'ready')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  (_ctx.element.partNumber)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('partNumber')) + ": " + _toDisplayString(_ctx.element.partNumber), 1),
                        _createElementVNode("button", {
                          class: "button is-white is-small copy-button",
                          type: "button",
                          "aria-label": _ctx.$t('copy'),
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (copyPartNumber(_ctx.element.partNumber)))
                        }, _hoisted_16, 8, _hoisted_14)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('threeD.callForAvailabilityAndPricing')), 1)
                ], 64))
              : _createCommentVNode("", true)
  ]))
}
}

})